import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Fragment, useEffect, useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { comparePlansDetails } from '@/src/constants/Pricing';
import { sendAnalyticsData } from '@/src/utils/analytics';
import type { IComparePlanSubItems, IComparePlansData, IPropsComparePlansData, IPropsComparePlansSubItems } from '../home.interface';
export const PricingTablularComparePlans = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Array(comparePlansDetails.length).fill(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isExpanded, setIsExpanded] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setTimeout(() => {
        setIsExpanded([true]);
      }, 100);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className="text-center text-[22px] font-medium text-[#3D3E40] lg:text-center lg:text-[36px]">Compare Plans</h1>;
    t4 = <p className="m-4 text-center text-lg font-normal text-[#555659] md:mx-0 lg:text-center">Individual paid plans are also available with limited upgrades</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-2 mr-9 flex justify-end gap-x-6 text-xs font-semibold text-[#555659] md:mx-24 md:mb-0 md:gap-x-20 md:text-xl"><p>Free</p><p>Custom</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isExpanded) {
    t6 = comparePlansDetails.map((comparePlansData, index) => {
      const dataForComparePlans = {
        comparePlansData
      };
      const {
        title,
        data
      } = dataForComparePlans.comparePlansData;
      return <Fragment key={index}><tr className="mb-5 mt-7 w-full rounded-xl bg-[#F6F7F8] p-4 md:mb-7 md:mt-5 md:px-6 md:py-5" key={index} onClick={() => {
          sendAnalyticsData("COMPARE_PLANS_ACCORDION_CLICKED", {
            title
          });
          const newExpanded = [...isExpanded];
          newExpanded[index] = !newExpanded[index];
          setIsExpanded(newExpanded);
        }}><td className="flex"><h2 className="w-full text-left font-semibold text-[#464E5F] md:text-xl">{title}</h2>{isExpanded[index] ? <FiChevronUp className="m-auto mx-2 scale-[2] text-[#818991]" /> : <FiChevronDown className="m-auto mx-2 scale-[2] text-[#818991]" />}</td></tr>{isExpanded[index] && data.map((comparePlanSubItem, subIndex) => {
          const dataForSubItems = {
            comparePlanSubItem
          };
          const {
            label,
            free,
            schools
          } = dataForSubItems.comparePlanSubItem;
          return <Fragment key={index + subIndex}><tr className="flex w-full items-center pl-4 md:mb-5 md:px-6 md:pl-0" key={index + subIndex}><th scope="row" className=" w-full py-3 text-left text-[15px] font-normal text-[#616366]  md:mx-6 lg:text-lg ">{label}</th><td className=" py-0 pl-4 pr-2 text-center md:pl-0 md:pr-20 xl:pr-20 2xl:pr-16">{free && <Image src="/images/icons/pricing/boolen-icon/Right.svg" alt="Right" className=" mx-auto h-full w-full md:h-5 md:w-14" width={20} height={20} />}{free === false && <Image src="/images/icons/pricing/boolen-icon/X.svg" alt="X" className="mx-auto h-full w-full md:h-6 md:w-14" width={20} height={20} />}</td><td className="py-0 pl-6 pr-8 text-center md:pl-4 md:pr-24">{schools === true ? <Image src="/images/icons/pricing/boolen-icon/Right.svg" alt="Right" className="mx-auto h-full w-full md:h-5 md:w-14" width={20} height={20} /> : <Image src="/images/icons/pricing/boolen-icon/X.svg" alt="X" className="mx-auto h-full w-full md:h-6 md:w-14" width={20} height={20} />}</td></tr></Fragment>;
        })}</Fragment>;
    });
    $[6] = isExpanded;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="mx-auto max-w-7xl">{t3}{t4}<div className="mt-8 md:mt-20">{t5}<table className="mx-4 -mt-10 w-[91%] md:mx-0 md:w-full"><tbody className="mb-6 mt-8 flex flex-col items-center justify-center md:w-full">{t6}</tbody></table></div></div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default PricingTablularComparePlans;